<mat-accordion>
    <mat-expansion-panel style="background-color: rgb(31, 33, 49);" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Reclutadores
        </mat-panel-title>
        <mat-panel-description>
  
  
        </mat-panel-description>
      </mat-expansion-panel-header>
  
      <mat-selection-list [multiple]="false">
        <div>
            <div *ngFor="let user of recruiters" style="color: rgb(80, 188, 255);">
              <mat-list-option [routerLink]="['/homeuser/recruiter/', user.id]">
                {{user.name | titlecase}} {{user.lastname | titlecase}}
              </mat-list-option>
            </div>
        </div>
  
      </mat-selection-list>
  
  
    </mat-expansion-panel>
  </mat-accordion>
